export default __webpack_public_path__ + "static/media/Gloves of Black Whispers.14e794cd.jpg";